import { connect } from 'react-redux';
import Fuse from 'fuse.js';
import React from 'react';
import PropTypes from 'prop-types';

import overrideStyle from 'lib/overrideStyle';

import SearchResultsContainer from 'presentation/selfService/SearchResults';
import { updateKBSearchResults, clearKBSearchResults, updateSelectedAnswer } from 'app/modules/knowledge_base/demo';
import { getAnswers, getKBSearchResults } from 'app/modules';

const Form = overrideStyle('form')`
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 50px;
    height: 57px;
    position: absolute;
    top: 72px;
    width: 316px;
`;

const Input = overrideStyle('input')`
 &[type=text] {
    align-items: flex-start;
    border: none;
    font-family: arial, helvetica, sans-serif;
    left: 20px;
    padding: 6px;
    position: absolute;
    top: 14px;
 }
`;

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusIndex: -1,
      fuse: createFuse(props.answersKB),
      shouldShowSearchResults: false,
      value: '',
    };

    Search.propTypes = {
      answersKB: PropTypes.array,
      onClear: PropTypes.func.isRequired,
      onSearch: PropTypes.func.isRequired,
      onSelectAnswer: PropTypes.func.isRequired,
      prompt: PropTypes.string.isRequired,
      searchResults: PropTypes.array,
    };

    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateFocusIndex = this.updateFocusIndex.bind(this);
  }

  handleBlur(ev) {
    this.setState({ focusIndex: -1, shouldShowSearchResults: false });
  }

  handleChange(ev) {
    this.props.onSearch({ fuse: this.state.fuse, searchTerm: ev.target.value });
    this.setState({ focusIndex: -1, shouldShowSearchResults: true, value: ev.target.value });
  }

  handleClear(ev) {
    ev.preventDefault();
    this.props.onClear();
    this.setState({ focusIndex: -1, shouldShowSearchResults: false, value: '' });
    this.input.focus();
  }

  handleFocus() {
    this.input.focus();
  }

  handleKeyDown(ev) {
    if (this.props.searchResults.length > 0) {
      if (ev.key === 'ArrowUp') {
        ev.preventDefault();
        this.updateFocusIndex(-1);
      } else if (ev.key === 'ArrowDown') {
        ev.preventDefault();
        this.updateFocusIndex(1);
      } else if (ev.key === 'Enter') {
        if (this.state.focusIndex > -1) {
          ev.preventDefault();
          this.props.onSelectAnswer(this.props.searchResults[this.state.focusIndex].id);
        }
      }
    }
  }

  handleMouseDown() {
    this.props.onMouseDown(this.props.answerId);
  }

  handleSubmit(ev) {
    let firstAnswer = this.props.searchResults[0];
    ev.preventDefault();
    // dont send unless there is at least one non-whitespace character, and there is a valid answer in results
    if (/\S+/.test(this.state.value) && typeof firstAnswer !== 'undefined') {
      this.props.onSelectAnswer(firstAnswer.id);
      this.setState({ focusIndex: -1, shouldShowSearchResults: false, value: '' });
    }
  }

  updateFocusIndex(value) {
    let max = this.props.searchResults.length;
    if (max === 0) {
      return;
    }
    let temp = this.state.focusIndex;
    temp += value;
    if (temp < 0) {
      temp = max - 1;
    }
    temp = Math.abs(temp) % (max + 1);
    this.setState({ focusIndex: temp });
  }

  renderSearchResults() {
    return this.state.shouldShowSearchResults ? (
      <SearchResultsContainer
        currentFocusIndex={this.state.focusIndex}
        onBlur={this.handleBlur}
        onClick={this.handleClear}
        onKeyDown={this.handleKeyDown}
        tabIndex="0"
        role="button"
        value={this.state.value}
      />
    ) : null;
  }

  render() {
    return (
      <React.Fragment>
        <Form role="searchbox" onSubmit={this.handleSubmit}>
          <Input
            tabIndex="0"
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onKeyDown={this.handleKeyDown}
            placeholder="Search"
            type="text"
            ref={input => (this.input = input)}
            value={this.state.value}
          />
        </Form>
        {this.renderSearchResults()}
      </React.Fragment>
    );
  }
}

function createFuse(kb) {
  let options = {
    id: 'id',
    keys: ['name'],
  };

  return new Fuse(kb, options);
}

function searchKnowledgeBase(fuse, searchTerm) {
  return !!searchTerm ? fuse.search(searchTerm) : [];
}

export const mapStateToProps = state => {
  return {
    answersKB: getAnswers(state),
    prompt: 'Search',
    searchResults: getKBSearchResults(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onClear: () => {
      dispatch(clearKBSearchResults());
    },
    onSearch: ({ fuse, searchTerm }) => {
      if (searchTerm === '') {
        dispatch(clearKBSearchResults());
      } else {
        let searchResults = searchKnowledgeBase(fuse, searchTerm);
        dispatch(
          updateKBSearchResults({
            searchResultAnswerIds: searchResults,
          })
        );
      }
    },
    onSelectAnswer: answerKey => {
      dispatch(
        updateSelectedAnswer({
          selectedResultAnswerId: answerKey,
        })
      );
      dispatch(clearKBSearchResults());
    },
  };
};

const SearchContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);

export default SearchContainer;
